export var allowNode = function (node, _, parent) {
  var _a;
  // @ts-expect-error - Mismatch of types.
  if (node.type == 'image' && ((_a = parent.children) === null || _a === void 0 ? void 0 : _a.length) > 1) {
    // Inline images are not allowed
    return false;
  }
  return true;
};
export var isModalUrl = function (url) {
  return url.startsWith('/modal/story/');
};
export var isUrlInternal = function (url) {
  return url.startsWith('/') || url.includes('deeplink') && (!url.startsWith('http') || url.includes('app.moneyfarm.com') || url.includes('app-test.moneyfarm.com') || url.includes('app-local.moneyfarm.com'));
};